import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-message-dialog',
  templateUrl: './message-dialog.component.html',
  styleUrls: ['./message-dialog.component.scss'],
})
export class MessageDialogComponent implements OnInit {
  @Input() full!: boolean;
  constructor(private termsModal: ModalController) {}

  ngOnInit(): void {}

  closeModal() {
    this.termsModal.dismiss();
  }
}
